<template>
  <div class="admin-page">
        <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
            <el-button type="primary" @click="refreshList">
              <el-icon><Refresh /></el-icon>
              刷新列表
            </el-button>
          </div>
        </div>
        
        <!-- 待审核用户列表 -->
        <el-table :data="pendingUsers" v-loading="loading" style="width: 100%">
          <el-table-column label="头像" width="80">
            <template #default="scope">
              <el-avatar 
                :size="40" 
                :src="scope.row.avatar"
                :alt="scope.row.nickname"
              >
                {{ scope.row.nickname?.charAt(0)?.toUpperCase() }}
              </el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="昵称" />
          <el-table-column prop="uuid" label="用户ID" width="120" />
          <el-table-column prop="sex" label="性别" width="60">
            <template #default="scope">
              {{ getSexText(scope.row.sex) }}
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" width="60" />
          <el-table-column prop="city" label="城市" />
          <el-table-column prop="occupation" label="职业" />
          <el-table-column prop="updatedAt" label="更新时间" width="160">
            <template #default="scope">
              {{ formatDate(scope.row.updatedAt) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template #default="scope">
              <el-button 
                size="small" 
                type="primary" 
                @click="viewAuditDetail(scope.row)"
              >
                审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <AdminPagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
    <!-- 审核详情对话框 -->
    <el-dialog
      v-model="auditDialogVisible"
      title="用户资料审核"
      width="90%"
      :close-on-click-modal="false"
    >
      <div v-if="auditDetail" class="audit-detail">
        <!-- 用户基本信息 -->
        <div class="user-basic-info">
          <div class="user-avatar">
            <el-avatar 
              :size="80" 
              :src="auditDetail.avatar"
              :alt="auditDetail.nickname"
            >
              {{ auditDetail.nickname?.charAt(0)?.toUpperCase() }}
            </el-avatar>
          </div>
          <div class="user-info">
            <h3>{{ auditDetail.nickname }}</h3>
            <p>用户ID: {{ auditDetail.uuid }}</p>
          </div>
        </div>

                 <!-- 资料对比表格 -->
         <div class="comparison-section">
           <h4>资料变更对比</h4>
           <el-table :data="comparisonData" border style="width: 100%">
             <el-table-column prop="field" label="字段" width="150" />
             <el-table-column label="原值" width="300">
               <template #default="scope">
                 <!-- 图片字段特殊处理 -->
                 <div v-if="['avatar', 'photo', 'photos'].includes(scope.row.fieldType)" class="image-comparison">
                   <div v-if="scope.row.fieldType === 'photos'" class="photos-display">
                     <span class="original-value">{{ scope.row.originalValue }}</span>
                     <div v-if="getOriginalPhotos().length > 0" class="photo-preview">
                       <el-image
                         v-for="(photo, index) in getOriginalPhotos().slice(0, 3)"
                         :key="index"
                         :src="photo"
                         fit="cover"
                         style="width: 40px; height: 40px; margin-right: 5px; border-radius: 4px;"
                       />
                       <span v-if="getOriginalPhotos().length > 3" class="more-photos">+{{ getOriginalPhotos().length - 3 }}</span>
                     </div>
                   </div>
                      <div v-else class="single-image-display">
                       <el-avatar 
                         v-if="getOriginalImageUrl(scope.row.fieldType)"
                         :size="60" 
                         :src="getOriginalImageUrl(scope.row.fieldType)"
                         fit="cover"
                         @error="() => console.log('Original image load failed:', scope.row.fieldType)"
                       />
                       <span v-else class="original-value">{{ scope.row.originalValue }}</span>
                     </div>
                 </div>
                 <!-- 普通字段 -->
                 <span v-else class="original-value">{{ scope.row.originalValue }}</span>
               </template>
             </el-table-column>
             <el-table-column label="新值" width="300">
               <template #default="scope">
                 <!-- 图片字段特殊处理 -->
                 <div v-if="['avatar', 'photo', 'photos'].includes(scope.row.fieldType)" class="image-comparison">
                   <div v-if="scope.row.fieldType === 'photos'" class="photos-display">
                     <span class="new-value">{{ scope.row.newValue }}</span>
                     <div v-if="getCurrentPhotos().length > 0" class="photo-preview">
                       <el-image
                         v-for="(photo, index) in getCurrentPhotos().slice(0, 6)"
                         :key="index"
                         :src="photo"
                         fit="cover"
                         style="width: 50px; height: 50px; margin-right: 5px; border-radius: 4px;"
                       />
                       <span v-if="getCurrentPhotos().length > 6" class="more-photos">+{{ getCurrentPhotos().length - 6 }}</span>
                     </div>
                   </div>
                   <div v-else class="single-image-display">
                     <el-avatar 
                       v-if="getCurrentImageUrl(scope.row.fieldType)"
                       :size="60" 
                       :src="getCurrentImageUrl(scope.row.fieldType)"
                       fit="cover"
                       @error="() => console.log('Current image load failed:', scope.row.fieldType)"
                     />
                     <span v-else class="new-value">
                       {{ scope.row.newValue }}
                       <span style="font-size: 12px; color: #999;">(Debug: {{ scope.row.fieldType }} = {{ auditDetail[scope.row.fieldType] }})</span>
                     </span>
                   </div>
                 </div>
                 <!-- 普通字段 -->
                 <span v-else class="new-value">{{ scope.row.newValue }}</span>
               </template>
             </el-table-column>
             <el-table-column prop="status" label="状态" width="100">
               <template #default="scope">
                 <el-tag 
                   :type="scope.row.status === 'changed' ? 'warning' : 'success'"
                   size="small"
                 >
                   {{ scope.row.status === 'changed' ? '已修改' : '未修改' }}
                 </el-tag>
               </template>
             </el-table-column>
           </el-table>
         </div>

        <!-- 照片审核 -->
        <div v-if="auditDetail.photos && auditDetail.photos.length > 0" class="photos-section">
          <h4>用户照片</h4>
          <div class="photo-grid">
            <div 
              v-for="(photo, index) in auditDetail.photos" 
              :key="index"
              class="photo-item"
            >
              <el-image
                :src="photo"
                :preview-src-list="auditDetail.photos"
                :preview-teleported="true"
                :z-index="5000"
                fit="cover"
                style="width: 120px; height: 120px"
              />
            </div>
          </div>
        </div>

        <!-- 审核操作 -->
        <div class="audit-actions">
          <el-form :model="auditForm" label-width="100px">
            <el-form-item label="审核结果">
              <el-radio-group v-model="auditForm.isAudited">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="审核备注">
              <el-input 
                v-model="auditForm.remark" 
                type="textarea" 
                :rows="3"
                placeholder="请输入审核备注（可选）"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="auditDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAudit" :loading="submitting">
            提交审核
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Refresh } from '@element-plus/icons-vue'
import AdminPagination from '@/components/AdminPagination.vue'
import axios from 'axios'
import { photoPathToUrl, resolveProfilePhotoUrl, mapPhotoListToUrls } from '@/utils/photoUpload'

export default {
  name: 'UserProfileAuditView',
  components: {
    AdminPagination,
    Refresh
  },
  setup() {
    const loading = ref(false)
    const submitting = ref(false)
    const pendingUsers = ref([])
    const currentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const auditDialogVisible = ref(false)
    const auditDetail = ref(null)
    const auditForm = ref({
      isAudited: 1,
      remark: ''
    })

    // 计算对比数据
    const comparisonData = ref([])
    const originalProfile = ref(null) // 存储原始资料

    // 格式化日期
    const formatDate = (timestamp) => {
      if (!timestamp) return ''
      const date = new Date(typeof timestamp === 'number' ? timestamp * 1000 : timestamp)
      return date.toLocaleString()
    }

    // 获取性别文本
    const getSexText = (sex) => {
      const sexMap = {
        'male': '男',
        'female': '女',
        'other': '其他'
      }
      return sexMap[sex] || sex
    }

    // 获取待审核用户列表
    const fetchPendingUsers = async () => {
      loading.value = true
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await axios.post('/api/v1/admin/user/profile/audit/list', {
          page: currentPage.value,
          pageSize: pageSize.value
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200) {
          pendingUsers.value = (response.data.data.users || []).map((u) => ({
            ...u,
            avatar: resolveProfilePhotoUrl(u.avatar, u.photo),
            photo: resolveProfilePhotoUrl(u.photo, u.avatar),
            photos: mapPhotoListToUrls(u.photos)
          }))
          total.value = response.data.data.total
        }
      } catch (error) {
        console.error('Error fetching pending users:', error)
        ElMessage.error('获取待审核用户列表失败')
      } finally {
        loading.value = false
      }
    }

    // 查看审核详情
    const viewAuditDetail = async (user) => {
      try {
        const token = localStorage.getItem('jwt_token')
        console.log('User data for audit:', user)
        console.log('User avatar field:', user.avatar)
        console.log('User photo field:', user.photo)
        console.log('All user fields:', Object.keys(user))
        
        // 调用API获取用户的原始资料
        const response = await axios.post('/api/v1/user/profile/get', {
          uuid: user.uuid
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200 && response.data.data) {
          const orig = response.data.data
          originalProfile.value = {
            ...orig,
            avatar: resolveProfilePhotoUrl(orig.avatar, orig.photo),
            photo: resolveProfilePhotoUrl(orig.photo, orig.avatar),
            photos: mapPhotoListToUrls(orig.photos)
          }
          auditDetail.value = {
            ...user,
            avatar: resolveProfilePhotoUrl(user.avatar, user.photo),
            photo: resolveProfilePhotoUrl(user.photo, user.avatar),
            photos: mapPhotoListToUrls(user.photos)
          }
          comparisonData.value = generateComparisonData(user, originalProfile.value)
          console.log('Original profile:', originalProfile.value)
          console.log('Current user data (auditDetail):', auditDetail.value)
          console.log('Comparison data:', comparisonData.value)
          debugImageUrls()
        } else {
          // 如果获取原始资料失败，使用当前资料
          originalProfile.value = null
          auditDetail.value = user
          comparisonData.value = generateComparisonData(user, null)
          console.log('Using current user data as auditDetail:', auditDetail.value)
        }
        
        auditForm.value = {
          isAudited: 1,
          remark: ''
        }
        auditDialogVisible.value = true
      } catch (error) {
        console.error('Error fetching audit detail:', error)
        // 如果API调用失败，使用当前资料
        originalProfile.value = null
        auditDetail.value = user
        comparisonData.value = generateComparisonData(user, null)
        auditForm.value = {
          isAudited: 1,
          remark: ''
        }
        auditDialogVisible.value = true
        ElMessage.warning('获取原始资料失败，将显示当前资料')
      }
    }

    // 格式化图片字段
    const formatImageField = (value, fieldType) => {
      console.log(`Formatting ${fieldType} field with value:`, value)
      if (!value || (typeof value === 'string' && value.trim() === '') || (typeof value !== 'string' && !value)) return '未上传'
      if (fieldType === 'photos' && Array.isArray(value)) {
        return value.length > 0 ? `${value.length}张照片` : '未上传'
      }
      if (fieldType === 'avatar' || fieldType === 'photo') {
        const result = value && (typeof value === 'string' ? value.trim() !== '' : true) ? '已上传' : '未上传'
        console.log(`Formatted ${fieldType}: ${result}`)
        return result
      }
      return '已上传'
    }

    // 获取原始图片URL
    const getOriginalImageUrl = (fieldType) => {
      if (!originalProfile.value) return null
      const url = originalProfile.value[fieldType]
      return url ? photoPathToUrl(url) || url : null
    }

    // 获取当前图片URL
    const getCurrentImageUrl = (fieldType) => {
      if (!auditDetail.value) return null
      const url = auditDetail.value[fieldType]
      return url ? photoPathToUrl(url) || url : null
    }

    // 获取当前照片数组
    const getCurrentPhotos = () => {
      if (!auditDetail.value || !auditDetail.value.photos) return []
      const photos = Array.isArray(auditDetail.value.photos) ? auditDetail.value.photos : []
      return photos.map((p) => photoPathToUrl(p) || p).filter(Boolean)
    }

    // 获取原始照片数组
    const getOriginalPhotos = () => {
      if (!originalProfile.value || !originalProfile.value.photos) return []
      const photos = Array.isArray(originalProfile.value.photos) ? originalProfile.value.photos : []
      return photos.map((p) => photoPathToUrl(p) || p).filter(Boolean)
    }

    // 调试方法：打印图片URL信息
    const debugImageUrls = () => {
      if (auditDetail.value) {
        console.log('Current avatar URL:', auditDetail.value.avatar)
        console.log('Current photo URL:', auditDetail.value.photo)
      }
      if (originalProfile.value) {
        console.log('Original avatar URL:', originalProfile.value.avatar)
        console.log('Original photo URL:', originalProfile.value.photo)
      }
    }

    // 生成对比数据
    const generateComparisonData = (user, originalProfile) => {
      const fields = [
        { key: 'nickname', label: '昵称' },
        { key: 'avatar', label: '头像', formatter: (val) => formatImageField(val, 'avatar') },
        { key: 'photo', label: '头像照片', formatter: (val) => formatImageField(val, 'photo') },
        { key: 'photos', label: '相册照片', formatter: (val) => formatImageField(val, 'photos') },
        { key: 'sex', label: '性别', formatter: (val) => getSexText(val) },
        { key: 'age', label: '年龄' },
        { key: 'birthday', label: '生日', formatter: (val) => val ? formatDate(val) : '未填写' },
        { key: 'height', label: '身高', formatter: (val) => val ? `${val}cm` : '未填写' },
        { key: 'weight', label: '体重', formatter: (val) => val ? `${val}kg` : '未填写' },
        { key: 'country', label: '国家' },
        { key: 'province', label: '省份' },
        { key: 'city', label: '城市' },
        { key: 'district', label: '区县' },
        { key: 'homeCountry', label: '家乡国家' },
        { key: 'homeProvince', label: '家乡省份' },
        { key: 'homeCity', label: '家乡城市' },
        { key: 'homeDistrict', label: '家乡区县' },
        { key: 'education', label: '学历' },
        { key: 'occupation', label: '职业' },
        { key: 'income', label: '收入' },
        { key: 'maritalStatus', label: '婚姻状况' },
        { key: 'boyCount', label: '男孩数量' },
        { key: 'girlCount', label: '女孩数量' },
        { key: 'religion', label: '宗教信仰' },
        { key: 'introduction', label: '自我介绍' },
        { key: 'hobbies', label: '兴趣爱好', formatter: (val) => Array.isArray(val) ? val.join(', ') : val },
        { key: 'tags', label: '个性标签', formatter: (val) => Array.isArray(val) ? val.join(', ') : val }
      ]

      return fields.map(field => {
        const currentValue = user[field.key]
        const originalValue = originalProfile ? originalProfile[field.key] : null
        
        const formattedCurrentValue = field.formatter ? field.formatter(currentValue) : (currentValue || '未填写')
        const formattedOriginalValue = field.formatter ? field.formatter(originalValue) : (originalValue || '未填写')
        
        // 判断是否有变更
        let hasChange = false
        if (originalProfile) {
          if (field.key === 'avatar' || field.key === 'photo') {
            // 对于图片字段，比较URL字符串
            const currentUrl = currentValue ? (typeof currentValue === 'string' ? currentValue.trim() : currentValue) : ''
            const originalUrl = originalValue ? (typeof originalValue === 'string' ? originalValue.trim() : originalValue) : ''
            hasChange = currentUrl !== originalUrl
            console.log(`Comparing ${field.key}: current="${currentUrl}" vs original="${originalUrl}", hasChange=${hasChange}`)
          } else {
            hasChange = JSON.stringify(currentValue) !== JSON.stringify(originalValue)
          }
        }
        
        return {
          field: field.label,
          originalValue: originalProfile ? formattedOriginalValue : '无法获取原值',
          newValue: formattedCurrentValue,
          status: hasChange ? 'changed' : 'unchanged',
          hasChange: hasChange,
          fieldType: field.key // 添加字段类型用于特殊处理
        }
      }).filter(item => item.hasChange || !originalProfile) // 如果有原值则只显示有变更的字段，否则显示所有字段
    }

    // 提交审核
    const submitAudit = async () => {
      if (!auditDetail.value) return

      try {
        await ElMessageBox.confirm(
          `确定要${auditForm.value.isAudited === 1 ? '通过' : '拒绝'}该用户的资料审核吗？`, 
          '确认审核', 
          {
            type: 'warning'
          }
        )

        submitting.value = true
        const token = localStorage.getItem('jwt_token')
        const response = await axios.post('/api/v1/admin/user/profile/audit', {
          //   userId: auditDetail.value.userId ,
          uuid: auditDetail.value.uuid,
          isAudited: auditForm.value.isAudited,
          remark: auditForm.value.remark || ''
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200) {
          ElMessage.success(auditForm.value.isAudited === 1 ? '审核通过，用户资料已更新' : '已拒绝该资料变更')
          auditDialogVisible.value = false
          fetchPendingUsers()
        } else {
          ElMessage.error(response.data.message || '审核提交失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error submitting audit:', error)
          ElMessage.error(error.response?.data?.message || '审核提交失败')
        }
      } finally {
        submitting.value = false
      }
    }

    // 刷新列表
    const refreshList = () => {
      fetchPendingUsers()
    }

    // 分页处理
    const handleSizeChange = (val) => {
      pageSize.value = val
      fetchPendingUsers()
    }

    const handlePageChange = (val) => {
      currentPage.value = val
      fetchPendingUsers()
    }

    onMounted(() => {
      fetchPendingUsers()
    })

    return {
      loading,
      submitting,
      pendingUsers,
      currentPage,
      pageSize,
      total,
      auditDialogVisible,
      auditDetail,
      auditForm,
      formatDate,
      getSexText,
      viewAuditDetail,
      submitAudit,
      refreshList,
      handleSizeChange,
      handlePageChange,
      comparisonData,
      getOriginalImageUrl,
      getCurrentImageUrl,
      getCurrentPhotos,
      getOriginalPhotos,
      debugImageUrls
    }
  }
}
</script>

<style scoped>

.audit-detail {
  padding: 20px 0;
}

.user-basic-info {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.user-avatar {
  margin-right: 20px;
}

.user-info h3 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #303133;
}

.user-info p {
  margin: 0;
  color: #606266;
}

.comparison-section {
  margin-bottom: 30px;
}

.comparison-section h4 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #303133;
}

.photos-section {
  margin-bottom: 30px;
}

.photos-section h4 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #303133;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 15px;
}

.photo-item {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.audit-actions {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.original-value {
  color: #909399;
  text-decoration: line-through;
}

.new-value {
  color: #409eff;
  font-weight: 500;
}

.image-comparison {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.single-image-display {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 60px;
}

.single-image-display .el-avatar {
  border: 2px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.photos-display {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.photo-preview {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.more-photos {
  font-size: 12px;
  color: #909399;
  background-color: #f5f7fa;
  padding: 4px 8px;
  border-radius: 12px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
}

@media (max-width: 768px) {
  .user-basic-info {
    flex-direction: column;
    text-align: center;
  }
  
  .user-avatar {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
}

</style> 